module.exports = __webpack_public_path__ + "static/img/ad1dab86-7e8d-4db3-b9cb-4c5c233f5918.894c3676.png";